import {
    ObjectContainerClientT,
    MappingClientT,
    ObjectTypeClientT,
    ObjectContainerClientDataT
} from 'bovaljaren-models';

const filterObjectsFromMappings = (objects?: ObjectContainerClientT[], mappingObjects?: MappingClientT[]): ObjectContainerClientT[] | undefined => {

    //Filtering, applied to check if object is defined in view, needs to be perfected when more data is available
    const filter = (object: ObjectContainerClientT): boolean => {
        return !!mappingObjects?.some(mo => mo.mappingEntityId === object.id);
    };

    return objects?.filter(filter);
};

/**
 * Used to create pairs of data for MaterialTable
 * @param objects List of Objectcontainers
 */
const mapDataFromObjects = (objects: ObjectContainerClientT[], objectTypes: ObjectTypeClientT[]): {[x: string]: {}}[] => {
    return objects.map(obj => {
        let data = {};
        const objectType = objectTypes.find(ot => ot.id === obj.objectTypeId);

        if (!objectType || !objectType.properties) {
            return data;
        }

        obj.data.forEach(d => {
            const prop = objectType?.properties.find(prop => prop.id === d.propId);
            const propName = prop?.name || '';

            data = {
                ...data,
                [propName]:d.value
            };
        });

        return data;
    });
};

const groupObjectsByObjectTypeId = (objects: ObjectContainerClientT[]): {[objectTypeId: number]: ObjectContainerClientT[]} => {
    const group = objects && objects.reduce((r, a): {[objectTypeId: number]: ObjectContainerClientT[]} => {
        r[a.objectTypeId] = [...r[a.objectTypeId] || [], a];

        return r;
    }, Object.create(null));

    return group;
};


const ObjectDataHandler = {
    getNumberOfRooms:(object: ObjectContainerClientT, objectType: ObjectTypeClientT): number | null => {
        const roomPropId = objectType.properties.find(prop => prop.type === 'rooms')?.id;
        const numberOfRooms: number = object.data.find(d => d.propId === roomPropId)?.value as unknown as number;

        return numberOfRooms ? numberOfRooms : null;
    },
    getNumberOfRoomsFromObjectArray:(objects: ObjectContainerClientT[], objectTypes: ObjectTypeClientT[]): number[] => {
        return objects.map(object => {
            const objectType = objectTypes.find(ot => ot.id === object.objectTypeId);

            if (!objectType) {
                return 0;
            }

            return ObjectDataHandler.getNumberOfRooms(object, objectType);
        }).filter(n => n !== null) as number[];
    },
    sortNumberOfRooms: (roomSizes: number[]): number[] => {
        return roomSizes.sort((a, b) => (a && b) ? a - b : 0);
    },
    getDistinctSortedRoomQuantities:(objects: ObjectContainerClientT[], objectTypes: ObjectTypeClientT[]): number[] => {
        if (!objects || !objects.length || !objectTypes || !objectTypes.length) {
            return [];
        }

        const roomsizeArray: number[] = [];

        new Set(
            ObjectDataHandler.sortNumberOfRooms(
                ObjectDataHandler.getNumberOfRoomsFromObjectArray(objects, objectTypes)
            )
        ).forEach(number => roomsizeArray.push(number));

        return roomsizeArray;

    }
};



const formatValue = (data: ObjectContainerClientDataT, type?: string): string | number => {

    if (type === 'floor' && data.value !== undefined && data.value !== null) {

        return (data.value as number === 0) ? 'BV' : data.value?.toLocaleString('sv');
    }

    if (type === 'rooms' && data.value !== undefined && data.value !== null) {
        return data.value?.toLocaleString('sv');
    }

    if (data && data.value !== undefined && data.value !== null) {
        if (data.baseType === 'number') {
            let value: number;

            if (typeof data.value === 'string') {
                value = Math.round(parseFloat(data.value));
            }
            else if (typeof data.value === 'number' &&
                !Number.isNaN(data.value) &&
                !Number.isInteger(data.value)) {
                value = Math.round(data.value) as number;
            }
            else if (typeof data.value === 'number') {
                value = Math.round(data.value) as number;
            }
            else {
                return `${data.value}`;
            }

            return value;
        }
        else if (data.baseType === 'boolean') {
            if ((typeof data.value) === 'boolean') {
                return data.value ? 'Ja' : 'Nej';
            }
            else {
                return ''; // Null or undefined
            }
        }
        else if (data.baseType === 'richDescription') {
            return data.value as string;
        }
        else {
            return `${data.value }`;
        }
    }
    else {
        return '';
    }

};

export { filterObjectsFromMappings, mapDataFromObjects, groupObjectsByObjectTypeId, ObjectDataHandler, formatValue };